export const handleDuplicates = (array: string[]): string[] => Array.from(new Set(array));

export const removeUndefined = (array) => array.filter((item) => item !== undefined);

export const updateObjectInArray = (
    array,
    key: string,
    valueToMatch: string,
    updateKey: string,
    updateValue: string | boolean,
) => {
    return array.map((item) => {
        return item[key] === valueToMatch ? { ...item, [updateKey]: updateValue } : item;
    });
};
